import {
  ICustomerItem,
  IKavDataItem,
} from "../../../../../modules/API/Drivers/models/kavData";

/**
 * Фильтрует кавы по AreaDesc, DriverName или имени любого из клиентов.
 * Опциональные цепочки повторяют легаси: DriverName и Customer_Name на практике
 * приходят пустыми, AreaDesc — нет.
 */
export const filterKavs = (
  list: IKavDataItem[],
  input: string
): IKavDataItem[] => {
  const search = input.toLowerCase();
  return list.filter(
    (item) =>
      item.AreaDesc.toLowerCase().includes(search) ||
      item.DriverName?.toLowerCase().includes(search) ||
      item.Customers.some((customer) =>
        customer.Customer_Name?.toLowerCase().includes(search)
      )
  );
};

/** Фильтрует клиентов кава по Customer_Name. */
export const filterCustomers = (
  customers: ICustomerItem[],
  input: string
): ICustomerItem[] => {
  const search = input.toLowerCase();
  return customers.filter((customer) =>
    customer.Customer_Name?.toLowerCase().includes(search)
  );
};
